import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useNavigate, useParams } from 'react-router-dom';
import * as API from '../../Endpoints/Endpoints'; // Adjust the path based on your project structure

const UpdateCategory = () => {
  const [categoryData, setCategoryData] = useState({
    gamecategory: '',
    gamecategoryname: '',
    gamecategorysymbol: '',
  });

  const navigate = useNavigate();
  const { gamecategoryid } = useParams(); // Ensure this is correct and available in the URL

  useEffect(() => {
    fetchCategoryData();
  }, [gamecategoryid]);  // Add gamecategoryid as a dependency to re-fetch when it changes
  
  const fetchCategoryData = () => {
    axios({
      url: API.GET_CATEGORY_BYID(gamecategoryid),
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    })
      .then((res) => {
        setCategoryData(res.data);  // Assuming the data is the full category object
      })
      .catch((err) => {
        alert('Error fetching category data: ' + err);
      });
  };
  

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setCategoryData({ ...categoryData, [name]: value });
  };

  const updateCategory = (e) => {
    e.preventDefault();
    axios.put(API.PUT_CATEGORY_API(gamecategoryid), categoryData, {
      headers: {
        'Content-Type': 'application/json',
      },
    })
      .then((res) => {
        alert('Category updated successfully');
        navigate('/categorytable'); // Navigate back to category table after successful update
      })
      .catch((err) => {
        console.error('Error updating category:', err);
        alert('Error updating category: ' + err.message);
      });
  };

  const goBack = () => {
    navigate('/categorytable'); // Go back to the category table
  };

  return (
    <div className="bg-[#B5B5B5] h-auto pb-20 pt-10">
      <div className="max-w-4xl mx-auto pt-10">
        <form onSubmit={updateCategory} className="bg-white shadow-md rounded px-8 pt-6 pb-8 mb-4">
          <div className="mb-4">
            <label className="block text-gray-700 text-sm font-bold mb-2">Game Category</label>
            <input
              type="text"
              name="gamecategory"
              value={categoryData.gamecategory}
              onChange={handleInputChange}
              className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
            />
          </div>

          <div className="mb-4">
            <label className="block text-gray-700 text-sm font-bold mb-2">Game Category Name</label>
            <input
              type="text"
              name="gamecategoryname"
              value={categoryData.gamecategoryname}
              onChange={handleInputChange}
              className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
            />
          </div>

          <div className="mb-4">
            <label className="block text-gray-700 text-sm font-bold mb-2">Game Category Symbol</label>
            <input
              type="text"
              name="gamecategorysymbol"
              value={categoryData.gamecategorysymbol}
              onChange={handleInputChange}
              className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
            />
          </div>

          <div className="flex items-center justify-between">
            <button
              type="submit"
              className="bg-[#e64a32] hover:bg-[#e64a32] text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline"
            >
              Update
            </button>
            <button
              type="button"
              onClick={goBack}
              className="bg-[#e64a32] hover:bg-[#e64a32] text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline"
            >
              Go Back
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default UpdateCategory;
